
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "./PowerBankDetails.css";

// Cookies
import Cookies from "universal-cookie";
import { getSubModulesByRoleId, getAllDataForDpp } from "store";
import { useLocation } from "react-router-dom";

import { Menu, MenuItem } from "@mui/material";

import Config from "../../config/index";
import { QRCodeCanvas } from "qrcode.react";

const cookies = new Cookies();

const PowerBankDetails = ({
  mainData,
  image,
  category,
  dppId,
  downloadReport,
  hasIndustryId,
  hasBatteryIndustry,
  hasSteelIndustry,

}) => {
  let baseUrl = Config.baseUrl;

  let loginDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails?.data?.roleId;

  const [showQR, setShowQR] = useState(false);
  const [logoStatus, setLogoStatus] = useState("loading");

  const { pathname, search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const urlDppId = queryParams.get("dppId") || queryParams.get("dppid");
  const urlDppCode = queryParams.get("dppCode") || queryParams.get("dppcode");

  const hasDppId = Boolean(urlDppId || urlDppCode);
  const isFromQRCode = pathname.toLowerCase() === "/dpp" && hasDppId;

  const brandLogoUrl = mainData?.mainCard?.productDetails?.brandLogoUrl;
  const dppCode = mainData?.mainCard?.productDetails?.dppCode;


  const routeToEncode = `/dpp?dppCode=${dppCode || ""}`;
  const encodedPath = btoa(routeToEncode);

  useEffect(() => {
    if (brandLogoUrl) {
      setLogoStatus("loading");
    } else {
      setLogoStatus("error");
    }
  }, [brandLogoUrl]);


  const [anchorEl, setAnchorEl] = useState(null);

  const openMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  // console.log("hasIndustssryId", hasIndustryId)
  const [showDownloadOptions, setShowDownloadOptions] = useState(false);
  const handleDownload = async (isExcel = 1) => {
    try {
      const response = await fetch(
        `${baseUrl}/dpp/get_report?roleId=${roleId}&dppCode=${dppCode}&isExcel=${isExcel}`
      );

      if (!response.ok) {
        throw new Error("Failed to download report");
      }

      const result = await response.json();

      if (!result?.data?.base64) {
        throw new Error("Invalid response");
      }

      const base64 = result.data.base64;

      // Decode Base64
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      // Create Blob
      const blob = new Blob([byteArray], {
        type: isExcel
          ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          : "application/json",
      });

      // Download
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = isExcel
        ? "DPP_Report.xlsx"
        : `DPP_Report${dppCode}.json`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error("Download failed:", error);
    }
  };
  const downloadQRCode = () => {
    const canvas = document.getElementById("qr-canvas");
    if (canvas) {
      const pngUrl = canvas
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");

      let downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = `DPP_QR_${dppCode || ""}.png`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  };

  return (
    <div className="pb-dpp-container">
      <div className="pb-image-section">
        <img
          src={image}
          alt={mainData?.mainCard?.productDetails?.productId}
          className="pb-product-image"
          loading="lazy"
        />
      </div>

      <div className="pb-details-section">

        {brandLogoUrl && (
          <div className="brand-logo" style={{ marginBottom: "10px" }}>

            {logoStatus === "loading" && (
              <div
                style={{
                  width: "120px",
                  height: "80px",
                  borderRadius: "8px",
                  background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                  backgroundSize: "200% 100%",
                  animation: "shimmer 1.5s infinite",
                }}
              />
            )}

            <img
              src={brandLogoUrl}
              alt="Brand Logo"
              style={{
                maxWidth: "120px",
                maxHeight: "120px",
                objectFit: "contain",
                display: logoStatus === "success" ? "block" : "none",
              }}
              onLoad={() => setLogoStatus("success")}
              onError={() => setLogoStatus("error")}
            />

            {/* Error state */}
            {logoStatus === "error" && (
              <div style={{ fontSize: "12px", color: "#999", padding: "8px 0" }}>
                Logo unavailable
              </div>
            )}

            {/* Shimmer animation CSS */}
            <style>{`
      @keyframes shimmer {
        0% { background-position: -200% 0; }
        100% { background-position: 200% 0; }
      }
    `}</style>
          </div>
        )}

        <h3 className="title">
          {mainData?.mainCard?.productDetails?.productId}
        </h3>
        <div className="tags">
          <span
            className="tag purple"
            style={{ textTransform: "none" }}
          >
            Batch/Serial No:{" "}
            {mainData?.mainCard?.productDetails?.serialNo || "NA"}
          </span>

          {category && (
            <span className="tag pink">
              {category}
            </span>
          )}
        </div>
        <p className="info">
          <strong>Brand Name:</strong>{" "}
          {mainData?.mainCard?.productDetails?.brandName}
        </p>
        <p className="info">
          <strong>Collection/Model:</strong>
          {mainData?.mainCard?.productDetails?.collectionModelType || "-"}
        </p>
        <p className="info">
          <strong>GTIN Number:</strong>
          {mainData?.mainCard?.productDetails?.gtinNumber || "-"}
        </p>
        <p className="info">
          <strong>Description:</strong>{" "}
          {mainData?.mainCard?.productDetails?.description}
        </p>


        {hasIndustryId && (
          <>
 
            <p className="info">
              <strong>SKU:</strong>{" "}
              {mainData?.mainCard?.productDetails?.sku || "-"}
            </p>
            <p className="info">
              <strong>Size:</strong>{" "}
              {mainData?.mainCard?.productDetails?.size || "-"}
            </p>
          </>
        )}

        <p className="info">
          <strong>Manufacturer:</strong>{" "}
          {mainData?.mainCard?.productDetails?.manufacturer}
        </p>

        <p className="info">
          <strong>Made in:</strong> {mainData?.mainCard?.productDetails?.madeIn}
        </p>
        <p className="info">
          <strong>Quantity:</strong>{" "}
          {mainData?.mainCard?.productDetails?.quantity} {""}
          {mainData?.mainCard?.productDetails?.quantityUOM}
        </p>
        <p className="info">
          <strong>Dimensions:</strong>{" "}
          {mainData?.mainCard?.productDetails?.dimensions?.trim() || "-"}
        </p>
        <p className="info">
          <strong>CE Marking:</strong>{" "}
          {mainData?.mainCard?.productDetails?.ceMarking?.trim() || "-"}
        </p>

        {hasBatteryIndustry && (
          <>
            <p className="info">
              <strong>Nominal Voltage:</strong>{" "}
              {mainData?.mainCard?.productDetails?.nominalVoltage?.trim() || "-"}
            </p>
            <p className="info">
              <strong>Power Rating:</strong>{" "}
              {mainData?.mainCard?.productDetails?.powerRating?.trim() || "-"}
            </p>
            <p className="info">
              <strong>Rated Capacity:</strong>{" "}
              {mainData?.mainCard?.productDetails?.ratedCapacity?.trim() || "-"}
            </p>

            <p className="info">
              <strong>Energy Density:</strong>{" "}
              {mainData?.mainCard?.productDetails?.energyDensity?.trim() || "-"}
            </p>
            <p className="info">
              <strong>Battery Cell Format:</strong>{" "}
              {mainData?.mainCard?.productDetails?.batteryCellFormat?.trim() || "-"}
            </p>
            <p className="info">
              <strong>Battery Chemistry:</strong>{" "}
              {mainData?.mainCard?.productDetails?.batteryChemistry?.trim() || "-"}
            </p>
          </>

        )}





        {hasSteelIndustry && (
          <>
            <p className="info">
              <strong>Customer Part Number:</strong>{" "}
              {mainData?.mainCard?.productDetails?.customerPartNumber?.trim() || "-"}
            </p>
            <p className="info">
              <strong>Drawing Revision:</strong>{" "}
              {mainData?.mainCard?.productDetails?.drawingRevision?.trim() || "-"}
            </p>
            <p className="info">
              <strong>Material Grade:</strong>{" "}
              {mainData?.mainCard?.productDetails?.materialGrade?.trim() || "-"}
            </p>
            <p className="info">
              <strong>Casting Process:</strong>{" "}
              {mainData?.mainCard?.productDetails?.castingProcess?.trim() || "-"}
            </p>
          </>
        )}

        <p className="info">
          <strong>Materials:</strong>{" "}
          {mainData?.mainCard?.rawMaterials?.join(" ") || "—"}
        </p>



        <div className="stats">
          <div className="stat-box">
            <p className="stat-label">Carbon Footprint</p>
            <p className="stat-value">
              {mainData?.mainCard?.productDetails?.carbonFootprint} kg CO₂
            </p>
          </div>
          <div className="stat-box">
            <p className="stat-label">Lifespan</p>
            <p className="stat-value">
              {mainData?.mainCard?.productDetails?.expectedLifespan} years
            </p>
          </div>
        </div>

        <div className="stat-box-container">
          <div className="stat-box materials-box">
            <p className="materials">
              <strong>Materials:</strong>
            </p>
            <div className="chip-wrapper">
              {mainData?.mainCard?.rawMaterials?.map((m, i) => (
                <div key={i} className="chip">
                  {m}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="stat-box-container">
          <div className="stat-box tests-box">
            <p className="materials">
              <strong>Tests:</strong>
            </p>
            <div className="chip-wrapper">
              {mainData?.testingTypes?.map((m, i) => (
                <div key={i} className="chip">
                  {m}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div
          className={`buttons ${!(downloadReport && roleId) ? "single-btn-container" : ""
            }`}
        >
          {downloadReport && roleId && (
            <>
              <button
                className="btn2 green"
                onClick={() => handleDownload(1)}
              >
                Download Excel
              </button>

              <button
                className="btn2 green"
                onClick={() => handleDownload(0)}
              >
                Download JSON
              </button>
            </>
          )}

          <button
            className="btn2 blue"
            onClick={() => setShowQR(true)}
          >
            QR Code
          </button>
        </div>      </div>

      {showQR && (
        <div className="qr-modal">
          <div className="qr-content" style={{ textAlign: "center" }}>
            <h3 style={{ marginBottom: "10px" }}>Scan QR Code</h3>

            <QRCodeCanvas
              id="mobile-qr-canvas"
              size={150}
              value={`${window.location.origin}/${encodedPath}`}
              style={{ margin: "0 auto" }}
            />

            <div style={{ display: "flex", justifyContent: "center", gap: "12px", marginTop: "20px" }}>

              <button
                onClick={downloadQRCode}
                style={{
                  backgroundColor: "#00b74a",
                  color: "#FFFFFF",
                  border: "none",
                  borderRadius: "8px",
                  padding: "8px 24px",
                  fontSize: "16px",
                  fontWeight: "700",
                  cursor: "pointer",
                  outline: "none"
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = "#00913b"}
                onMouseLeave={(e) => e.target.style.backgroundColor = "#00b74a"}
              >
                Download
              </button>

              <button
                onClick={() => setShowQR(false)}
                style={{
                  backgroundColor: "#2D68FE",
                  color: "#FFFFFF",
                  border: "none",
                  borderRadius: "8px",
                  padding: "8px 24px",
                  fontSize: "16px",
                  fontWeight: "700",
                  cursor: "pointer",
                  outline: "none"
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = "#1E4ED8"}
                onMouseLeave={(e) => e.target.style.backgroundColor = "#2D68FE"}
              >
                Close
              </button>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getAllDataForDppReducer: state.getAllDataForDppReducer,
    getUnmappedDocumentTypeReducer: state.getUnmappedDocumentTypeReducer,
    getUnmappedUsersDetailsReducer: state.getUnmappedUsersDetailsReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PowerBankDetails);